<app-ice-card>
  <section class="condition-assessment-section">
    <header class="condition-assessment-section-heading">2/{{ numberOfSteps }} Tilstandssjekk</header>
    <div class="condition-assessment-text">
      Her skal du oppgi hvilken tilstand telefonen er i. Normal slitasje er greit, og når du har andre skader så vil du
      normalt kunne bruke forsikringen som følger med i MobilBytte-avtalen.
    </div>
    <div class="condition-assessment-link">
      <a
        data-testid="open-condition-check-guide-link"
        href="https://www.ice.no/globalassets/dokumenter/gradering-ice-mobilbytte_forsikring-1.pdf"
        target="_blank"
      >
        Åpne guide for tilstandssjekk
      </a>
    </div>
    <div [formGroup]="form">
      @for (question of gradingQuestions; track $index) {
        <div class="grading-question">
          <div class="grading-question-header">
            <header class="grading-question-label" id="grading-question">{{ question.question }}</header>
            <div class="grading-question-details">
              <a
                class="grading-question-link"
                data-testid="grading-question-link"
                tabindex="0"
                (click)="question.isCollapsed = !question.isCollapsed"
                (keydown.enter)="question.isCollapsed = !question.isCollapsed"
              >
                Les mer om dette punktet
              </a>
              @if (!question.isCollapsed) {
                <div>{{ question.description }}</div>
              }
            </div>
          </div>
          <div class="radio-group">
            <mat-radio-group [formControl]="$any(form).get(question.questionType)">
              <app-radio-button-list [isHorizontalAlignment]="true">
                <app-radio-button-list-item [control]="form.controls[question.questionType]" [value]="true">
                  Ja
                </app-radio-button-list-item>
                <app-radio-button-list-item [control]="form.controls[question.questionType]" [value]="false">
                  Nei
                </app-radio-button-list-item>
              </app-radio-button-list>
            </mat-radio-group>
          </div>
        </div>
      }
    </div>
    @if (insuranceEligibility && !insuranceEligibility.mustUseInsurance) {
      <div class="insurance-alert">
        <app-ice-alert type="success" [iconName]="IconNames.ice_tick">
          Flott, alt er i orden! Ingen forsikring nødvendig.
        </app-ice-alert>
      </div>
    }
  </section>
  <div class="form-buttons">
    <app-ice-button color="secondary" testId="mobile-phone-grading-step-back-button" (click)="onNavigateToPreviousStep()">
      Tilbake
    </app-ice-button>
    @if (insuranceEligibility && !insuranceEligibility.mustUseInsurance) {
      <app-ice-button color="primary" testId="submit-mobile-phone-grading-button" (click)="gradingCompleted.emit()">
        Ferdig
      </app-ice-button>
    } @else {
      <app-ice-button
        color="primary"
        testId="mobile-phone-grading-step-forward-button"
        [disabled]="form.invalid"
        [isLoading]="isLoadingGradingAnswers"
        (click)="onNextStep()"
      >
        Neste
      </app-ice-button>
    }
  </div>
</app-ice-card>
